module.exports = __webpack_public_path__ + "static/media/RepostPaymentScreen.4808531e.png";